import { UserManager, WebStorageStateStore, User } from 'oidc-client';
import { apiIdentityServerHost, redirectUri, postLogoutRedirectUri, clientId } from '@/api/urls';

export default class AuthService {
    private userManager: UserManager;

    constructor() {
        const AUTH0_DOMAIN: string = apiIdentityServerHost;

        const settings: any = {
            userStore: new WebStorageStateStore({ store: window.localStorage }),
            authority: AUTH0_DOMAIN,
            client_id: clientId,
            redirect_uri: `${redirectUri}`,
            response_type: 'code',
            scope: 'openid profile Neocom.ControlPanel.Api',
            acr_values: 'controlpanel',
            post_logout_redirect_uri: `${postLogoutRedirectUri}`,
        };

        this.userManager = new UserManager(settings);
    }

    public getUser(): Promise<User | null> {
        return this.userManager.getUser();
    }

    public login(): Promise<void> {
        return this.userManager.signinRedirect();
    }

    public logout(): Promise<void> {
        return this.userManager.signoutRedirect();
    }

    public getAccessToken(): Promise<string> {
        return this.userManager.getUser().then((data: any) => {
            return data.access_token;
        });
    }

    public isAuthenticated() {
        return this.userManager.getUser()
          .then((user) => {
              return user !== null;
           });
    }
}
